
export const noPermissions  = new Map<string,Set<string>>([
	[ 'points', new Set<string>([ ])], 
	[ 'layers', new Set<string>([ ])], 
	[ 'filter', new Set<string>([ ])], 
	[ 'comments', new Set<string>([ ])], 
	[ 'projects', new Set<string>([ ])], 
]);

export const RoleDefinition = new Map<string, Map<string,Set<string>>>([
	[ 'entwickler',  new Map<string,Set<string>>(
		[
			[ 'points', new Set<string>([ 'add', 'read', 'write', 'checkin', 'checkout' ])], 
			[ 'layers', new Set<string>([ 'read' ])], 
			[ 'filter', new Set<string>([ 'use' ])], 
			[ 'comments', new Set<string>([ 'read', 'write' ])], 
			[ 'projects', new Set<string>([ 'manage' ])], 
		])
	], 
	[ 'manager',  new Map<string,Set<string>>(
		[
			[ 'points', new Set<string>([ 'read', 'checkout' ])], 
			[ 'layers', new Set<string>([ 'read' ])], 
			[ 'filter', new Set<string>([ 'use' ])], 
			[ 'comments', new Set<string>([ 'read', 'write' ])], 
			[ 'projects', new Set<string>([ 'manage' ])], 
		])
	], 
	[ 'datennutzer',  new Map<string,Set<string>>(
		[
			[ 'points', new Set<string>([ 'read' ])], 
			[ 'layers', new Set<string>([ 'read' ])], 
			[ 'filter', new Set<string>([ 'use' ])], 
			[ 'comments', new Set<string>([ ])], 
			[ 'projects', new Set<string>([ ])], 
		])
	], 
	[ 'gast',  new Map<string,Set<string>>(
		[
			[ 'points', new Set<string>([ 'read' ])], 
			[ 'layers', new Set<string>([ ])], 
			[ 'filter', new Set<string>([ ])], 
			[ 'comments', new Set<string>([ ])], 
			[ 'projects', new Set<string>([ ])], 
		])
	], 
	[ 'kartierer',  new Map<string,Set<string>>(
		[
			[ 'points', new Set<string>([ 'add', 'read', 'write', 'checkin', 'checkout' ])], 
			[ 'layers', new Set<string>([ 'read' ])], 
			[ 'filter', new Set<string>([ 'use' ])], 
			[ 'comments', new Set<string>([ 'read', 'write' ])], 
			[ 'projects', new Set<string>([ ])], 
		])
	], 
	[ 'kontrolleur',  new Map<string,Set<string>>(
		[
			[ 'points', new Set<string>([ 'read', 'write', 'checkin', 'checkout' ])], 
			[ 'layers', new Set<string>([ 'read' ])], 
			[ 'filter', new Set<string>([ 'use' ])], 
			[ 'comments', new Set<string>([ 'read', 'write' ])], 
			[ 'projects', new Set<string>([ ])], 
		])
	] 
]);
